export default __webpack_public_path__ + "media/images/react_icons/angle-down-72db7aadaefc91ec24b017d463be6484.svg";